import React, { useState, useContext, useEffect } from "react";
import BASE_URLS from "../baseUrl";
import { useContact } from "./ContactContext";
import Loader from "../Loader";

const CurrContext = React.createContext();

//Hook method
export function useCurr() {
  return useContext(CurrContext);
}

export function CurrencyProvider(props) {
  const [currDrop, setcurrDrop] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState(
    localStorage.getItem("curr_selected") !== ""
      ? localStorage.getItem("curr_selected")
      : "AED"
  );
  const mainApiUrl = BASE_URLS.main;

  const { addr, loading } = useContact();

  useEffect(() => {
    if (addr) {
      setSelectedCurrency(addr?.country_curr);
      localStorage.setItem("curr_selected", addr?.country_curr);
      setcurrDrop(addr?.cont_arr);
    }
  }, [addr, setSelectedCurrency]);


  // This provider wraps the whole app, so while the settings request is in
  // flight nothing else can render. Show the same skeleton the rest of the
  // boot sequence uses rather than #preloader, whose animation starts as a
  // 10px ring and reads as a stray blue dot on an empty page.
  if (loading) {
    return <Loader />;
  }

  const currConvert = (price) => {
    if (parseFloat(price) === 0) {
      return price;
    } else {
      return (
        parseFloat(price) * getExchangeRateByCurrency(selectedCurrency)
      ).toFixed(2);
    }
  };

  const currConvertOG = (price) => {
    if (parseFloat(price) === 0) {
      return price;
    } else {
      return (
        parseFloat(price) / getExchangeRateByCurrency(selectedCurrency)
      ).toFixed(2);
    }
  };

  const getExchangeRateByCurrency = (currency) => {
    const country = currDrop.find((item) => item.country_curr == currency);
    return country ? country.country_curr_ex_rate : 1;
  };

  const value = {
    currDrop,
    selectedCurrency,
    setSelectedCurrency,
    currConvert,
    currConvertOG,
  };

  return (
    <CurrContext.Provider value={value}>{props.children}</CurrContext.Provider>
  );
}
